import { render, staticRenderFns } from "./ForumCategoriaAdmin.vue?vue&type=template&id=2f2a46c7&scoped=true"
import script from "./ForumCategoriaAdmin.vue?vue&type=script&lang=js"
export * from "./ForumCategoriaAdmin.vue?vue&type=script&lang=js"
import style0 from "./ForumCategoriaAdmin.vue?vue&type=style&index=0&id=2f2a46c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2a46c7",
  null
  
)

export default component.exports